export const EMAIL_REGEXP = /^([_a-zA-Z0-9-+]{2,60})+(\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9-]{2,60})+(\.([a-zA-Z0-9-]{2,60})+)+$/i;

export const DEF_LOCAL = "de";

export const Y_COUNTER = "yaCounter51167738";

export const MERCHANTS_PER_PAGE = 32;

export const URL =
  process.env.VUE_APP_SERVER === "prod"
    ? "https://editorapi.nakarta.com"
    : "https://editorapi_nakarta.abz.dev";
